/**
 * @Description 按钮状的tabs
 */
import { FC } from 'react';
import V2Tabs from '../Data/V2Tabs';
import { TabsProps } from 'antd';
import styles from './index.module.less';
import cs from 'classnames';

// 带搜索和重置按钮的form
export interface ButtonTabsProps extends TabsProps {
  noDropDown?: boolean;
  colorType?: 'lightBlue' // lightBlue 浅蓝色
}


const ButtonTabs: FC<ButtonTabsProps> = ({ items, className, noDropDown, colorType, ...props }) => {
  return (
    <>
      <V2Tabs
        items={items}
        type='fullCard'
        animated={false}
        className={cs([
          styles['tabs-button'],
          className,
          noDropDown ? styles['no-drop-down'] : '',
          colorType === 'lightBlue' ? styles['light-blue'] : '',
        ])}
        {...props}/>
    </>
  );
};

export default ButtonTabs;
